import React, { useEffect, useRef } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import { NOTIFICATION_TYPES } from '../../Login/constants';
import type { NotificationVariantTypes } from '../../Login/types';

import errorIcon from '../../images/error.png';
import successIcon from '../../images/success.png';
import closeIcon from '../../images/close.svg';
import messages from './messages';

interface NotificationsProps {
  title: string;
  message: React.ReactNode;
  count: number;
  variant?: NotificationVariantTypes;
}

const Notifications = ({
  title,
  message,
  count,
  variant = NOTIFICATION_TYPES.ERROR,
}: NotificationsProps): React.ReactElement => {
  const notificationRef = useRef<HTMLDivElement | null>(null);

  const intl = useIntl();

  const iconMap = {
    [NOTIFICATION_TYPES.ERROR]: {
      icon: errorIcon,
      alt: intl.formatMessage(messages.errorIconAlt),
    },
    [NOTIFICATION_TYPES.SUCCESS]: {
      icon: successIcon,
      alt: intl.formatMessage(messages.successIconAlt),
    },
  };

  const closeNotification = () => {
    if (notificationRef.current) {
      notificationRef.current.style.display = 'none';
    }
  };

  useEffect(() => {
    if (notificationRef.current) {
      notificationRef.current.style.display = 'flex';
    }
  }, [count]);

  return (
    <div className="notifications-block" ref={notificationRef}>
      <div className="notification-element error">
        <div className="notification-header-block">
          <img
            src={iconMap[variant].icon}
            alt={iconMap[variant].alt}
            className="notification-header-block-icon"
          />
          <div className="notification-header-title">
            {title}
          </div>
        </div>
        <div className="notification-body">
          {message}
        </div>
        <button
          type="button"
          onClick={closeNotification}
          className="notification-close"
        >
          <img
            src={closeIcon}
            alt={intl.formatMessage(messages.closeIconAlt)}
            className="notification-close-icon"
          />
        </button>
      </div>
    </div>
  );
};

export default Notifications;
